// extracted by mini-css-extract-plugin
export default {"plan-desc-wrapper":"plan-desc-wrapper_Aea_4","button-group":"button-group_SK7TB"};